import { render, staticRenderFns } from "./HistoricSales.vue?vue&type=template&id=870eb9d0"
import script from "./HistoricSales.vue?vue&type=script&lang=js"
export * from "./HistoricSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports